<div class="enquiryMain">
  <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
  </div>
  <!-- <app-public-header  [company]="company" [branch]="branch"></app-public-header> -->
  <div class="enquiryBody">
      <div>
          <h1 class="enquiryHeading">{{setLabel("demoAccessFormLabel")}}</h1>
          <h3 class="enquiryHeading" style="color: rgb(255, 85, 0);">{{setLabel("accessDemoLabel")}}</h3>
          <!-- <p class="enquiryHeading" style="color: rgb(255, 85, 0); font-weight: 700;">Once you've submitted the required information, you'll be granted immediate access to explore our system.</p> -->

      </div>
      <div class="card , formMain" style="margin-top: 35px;">
          <div class="apiResponceMessage"  *ngIf="isMessage">
              <div style=" position: relative;">
                  <p-message class="errors" *ngIf="isMessage && isError" severity="error" text="{{message}}"></p-message>
                  <span style="position: absolute; top: 0; right: 5px; cursor: pointer; font-size: 17px; color: #E9E4D4;" (click)="errorMsgClose()" *ngIf="isError || isSuccess">
                      <i class="fa fa-times"></i>
                  </span>
              </div>
          </div>
          <form class="form" #form="ngForm" (ngSubmit)="submit(form)">
              <div>
                  <div class="ui-inputgroup , inputMain">
                      <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-user"
                              aria-hidden="true"></i></span>
                      <input class="input" type="text" id="username" #username="ngModel" [(ngModel)]="fullName" required
                          pattern="[A-Za-z ]+" autocomplete="off" [placeholder]='setLabel("name*Placeholder")' maxlength="100" name="name"
                          [ngClass]="username.invalid && (username.dirty || username.touched) ? 'errorInput' : '' ">
                      <div class="errorFixNew" *ngIf="username.invalid && (username.dirty || username.touched)">
                          <div *ngIf="username.errors.required" class="errorShow">
                              {{setLabel("enterNameLabel")}}
                          </div>
                          <div *ngIf="username.errors.pattern" class="errorShow">
                              {{setLabel("containLettersLabel")}}
                          </div>
                      </div>
                  </div>
              </div>
              
                      <div>
                        <div class="ui-inputgroup , inputMain">
                            <span class="ui-inputgroup-addon">
                                <i style="width: 15px !important;" class="fa fa-phone" aria-hidden="true"></i>
                            </span>
                            <app-phone-input
                                [placeholder]='setLabel("mobileNumberLabel")'
                                [(phoneNumber)]="phoneNumber"
                                [initialCountry]="'PK'"
                                (formattedForSaving)="phoneNumber = $event"
                                (isValidNumber)="isPhoneValid = $event"
                                style="width: 100%;">
                            </app-phone-input>
                            <div class="errorFixNew" *ngIf="phoneNumber && !isPhoneValid">
                                <div class="errorShow">
                                    {{setLabel("validMobileErrorLabel")}} {{errorExempleNumber}}
                                </div>
                            </div>
                            <div class="errorFixNew" *ngIf="!phoneNumber">
                                <div class="errorShow" *ngIf="form.submitted">
                                    {{setLabel("mobileNumberLabel")}}
                                </div>
                            </div>
                        </div>
                </div>
                <div>
                <div class="ui-inputgroup , inputMain">
                      <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-envelope"
                              aria-hidden="true"> </i></span>
                      <input maxlength="256" class="input" #email="ngModel"
                          [ngClass]="email.invalid && (email.dirty || email.touched) ? 'errorInput' : '' " 
                          pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" [(ngModel)]="emailAdress" 
                          (focus)="setEmailPlaceholder('john@example.com')" (blur)="resetEmailPlaceholder()" type="text" id="Email" autocomplete="off" [placeholder]="EmailplaceholderText" name="email">
                          <div class="errorFixNew">
                            <ng-template [ngIf]="email.invalid && (email.dirty || email.touched)">
                              <div>
                                <div *ngIf="email.errors.pattern" class="errorShow">
                                    {{setLabel("validEmailLabel")}}
                                  </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>
                </div>
                <div>
                    <div class="ui-inputgroup , inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-building"
                                aria-hidden="true"></i></span>
                        <input class="input" type="text" id="gymname" #gymname="ngModel" ngModel
                            pattern="[A-Za-z ]+" autocomplete="off" [placeholder]='setLabel("gymName*Placeholder")' maxlength="100" name="gymName">
                    </div>
                </div>
                <div>
                <div class="city-country-inputs" style="position: relative;">
                  <span class="ui-inputgroup-addon" style="position: absolute; left: 11px"><i style="width: 15px !important;" class="fa fa-map-marker"
                    aria-hidden="true"></i></span>
                  <input class="input city-input" type="text" id="city" #city="ngModel" ngModel autocomplete="off"  [placeholder]='setLabel("cityPlaceholder")' name="city">
                  <!-- <input class="input country-input" type="text" id="country" #country="ngModel" ngModel autocomplete="off"  [placeholder]='setLabel("countryPlaceholder")' name="country"> -->
                </div>
              </div>
              <div class="saveMain">
                  <button
                      type="submit"
                      class="saveButton p-button submitButton p-widget p-state-defaultp-corner-all"
                      [disabled]="loading || !isPhoneValid">
                      <span class="ui-button-text ui-c">
                          <i class="fa fa-save" aria-hidden="true"></i> &nbsp;{{setLabel("proceedDemoLabel")}}
                      </span>
                   </button>
                  </div>
          </form>

      </div>
  </div>
  <!-- <app-public-footer [branch]="branch"></app-public-footer> -->
</div>
